module.exports = __webpack_public_path__ + "img/logo-MBE-OnLine.a8db3e1d.svg";